import React, { useEffect, useRef, useState } from "react";
import { ChevronDown, Plus, X } from "lucide-react";
import { Input } from "./ui/input";
import { namaGelar } from "../lib/utils";

const pecah = (v) => (v || "").split(/[,\n;]/).map((s) => s.trim()).filter(Boolean);

// Satu baris nama dengan dropdown pencarian dari Direktori Jemaat (saran = [{nama, bidang}]).
export const BarisNama = ({ value, onChange, onHapus, placeholder, saran, highlight, testId }) => {
  const [buka, setBuka] = useState(false); const box = useRef(null);
  useEffect(() => { const h = (e) => { if (box.current && !box.current.contains(e.target)) setBuka(false); }; document.addEventListener("mousedown", h); return () => document.removeEventListener("mousedown", h); }, []);
  const q = value.trim().toLowerCase();
  const [semua, setSemua] = useState(false);
  const hasil = q.length >= 1 ? saran.filter((s) => s.nama.toLowerCase().includes(q)).slice(0, 8) : semua ? saran.slice(0, 50) : [];
  const persis = hasil.length === 1 && hasil[0].nama.toLowerCase() === q;
  const tutup = () => { setBuka(false); setSemua(false); };
  useEffect(() => { if (!buka) setSemua(false); }, [buka]);
  return (
    <div ref={box} className="relative flex items-center gap-1">
      <div className="relative flex-1">
        <Input value={value} placeholder={placeholder} autoComplete="off"
          onChange={(e) => { onChange(e.target.value.replace(/[,;]/g, "")); setBuka(true); setSemua(false); }} onFocus={() => setBuka(true)}
          className={`min-h-[36px] rounded-lg text-sm pr-7 ${highlight ? "ring-2 ring-amber-400 bg-amber-50" : ""}`} data-testid={testId} />
        <button type="button" aria-label="Buka daftar nama" onMouseDown={(e) => e.preventDefault()} onClick={() => { if (buka && semua) tutup(); else { setBuka(true); setSemua(true); } }}
          className="absolute right-1 top-1/2 -translate-y-1/2 h-6 w-6 rounded text-slate-500 hover:text-slate-800 hover:bg-slate-100 flex items-center justify-center" data-testid={`${testId}-panah`}><ChevronDown className="h-3.5 w-3.5" /></button>
      </div>
      {value.trim() ? <button type="button" aria-label="Hapus nama" onClick={onHapus} className="h-8 w-8 rounded-lg text-slate-400 hover:text-red-600 hover:bg-red-50 flex items-center justify-center shrink-0" data-testid={`${testId}-hapus`}><X className="h-3.5 w-3.5" /></button>
        : <span className="h-8 w-8 shrink-0 flex items-center justify-center text-slate-300" title="Tambah nama"><Plus className="h-3.5 w-3.5" /></span>}
      {buka && (hasil.length > 0 || semua) && !persis && (
        <div className="absolute z-30 top-full left-0 mt-1 w-[calc(100%-2.25rem)] min-w-[220px] rounded-xl border bg-white shadow-lg max-h-56 overflow-auto text-sm" data-testid={`${testId}-dropdown`}>
          {hasil.length === 0 && <div className="px-3 py-2 text-xs text-slate-400" data-testid={`${testId}-kosong`}>Belum ada jemaat dengan bidang pelayanan ini</div>}
          {hasil.map((s) => (
            <button key={s.nama} type="button" onMouseDown={(e) => e.preventDefault()} onClick={() => { onChange(s.nama); tutup(); }} className="w-full text-left px-3 py-2 hover:bg-slate-50 flex items-center justify-between gap-2" data-testid={`${testId}-opsi-${s.nama.replace(/\s+/g, "-")}`}>
              <span className="truncate">{namaGelar(s)}</span>{s.bidang?.length > 0 && <span className="text-[10px] text-slate-400 truncate max-w-[45%]">{s.bidang.join(", ")}</span>}
            </button>))}
        </div>)}
    </div>
  );
};

// Input multi-nama (disimpan sebagai satu string dipisah ", "). State baris lokal agar spasi saat mengetik tidak hilang.
export const MultiNamaInput = ({ value, onChange, maks = 2, saran = [], testId, highlight = false }) => {
  const [rows, setRows] = useState(() => pecah(value));
  useEffect(() => { if (pecah(value).join("|") !== pecah(rows.join(", ")).join("|")) setRows(pecah(value)); }, [value]); // eslint-disable-line react-hooks/exhaustive-deps
  const commit = (arr) => { setRows(arr); onChange(arr.map((s) => s.trim()).filter(Boolean).join(", ")); };
  const ubah = (i, v) => { const a = [...rows]; a[i] = v; commit(a); };
  const hapus = (i) => commit(rows.filter((_, k) => k !== i));
  const terisi = rows.filter((s) => s.trim()).length;
  const tampil = terisi < maks && rows.every((s) => s.trim()) && rows.length < maks ? [...rows, ""] : rows;
  return (
    <div className="space-y-1" data-testid={testId}>
      {tampil.map((n, i) => <BarisNama key={i} value={n} saran={saran} highlight={highlight} placeholder={`Nama ${i + 1}`} testId={`${testId}-${i}`} onChange={(v) => ubah(i, v)} onHapus={() => hapus(i)} />)}
      <div className="text-[10px] text-slate-400 pl-1">{terisi}/{maks} nama</div>
    </div>
  );
};

export const pecahNama = pecah;
